import React, { FC } from 'react';
import Image from 'next/image';
import styles from './ClientBanner.module.scss';
import classNames from 'classnames';
import parse from 'html-react-parser';
// Import lib files
import { bannerProps } from '@/libs/interfaceProps/bannerProps';
import currentDateTimeStamp from '@/libs/currentDateTimestamp/currentDateTimestamp';
import TruncateReadmore from '@/components/TruncateReadmore/TruncateReadmore';
import { useEnvContext } from '@/context/envContext';
import { sanitizeTitle } from '@/libs/sanitizeTitle/sanitizeTitle';
import { orgBannerProps } from '@/libs/interfaceProps/orgBannerProps';
import { useOrgContext } from '@/context/orgContext';
const ClientLogoBanner: FC<bannerProps> = ({
  t
}) => {
  const {
    cdnEnv: env
  } = useEnvContext();
  const {
    orgData
  } = useOrgContext();

  // Todo Add  orgCoverImage to this const list
  const {
    orgName,
    orgDescription,
    orgNumFound,
    orgUrl,
    images
  }: orgBannerProps = orgData;

  // Build a display name for the client site link
  // function is only called from within the query check for valid orgUrl
  // try/catch  for mallformed strings added on this ap-884 commit based on the ticket originally raised:
  // https://ttgt.atlassian.net/browse/AP-438
  function orgSiteName(url: string) {
    try {
      const orgSiteNameParts = new URL(url);
      // from the parts get the hostname e.g 'www.example.com'
      let orgHostName = orgSiteNameParts.hostname;
      // split the hostname into an array www, example, com
      let orgHostNameParts = orgHostName.replace('www.', '').split('/');
      // rebuild the parts without the 'www' part
      return orgHostNameParts[0];
    } catch (e) {
      // If URL is invalid, it might be missing a protocol.
      let orgHostNameParts = url.replace('https://', '').replace('http://', '').replace('www.', '').split('/');
      return orgHostNameParts[0];
    }
  }
  const resourcesIcon = `${env}/rms/images/icons/resources-icon.svg`;
  const orgIcon = `${env}/rms/public/icons/link-icon.svg`;
  return <div className={'banners client-banner ' + styles['client-logo-banner']} data-bdd={'client-logo-banner'} data-sentry-component="ClientLogoBanner" data-sentry-source-file="ClientLogoBanner.tsx">
   <div className={styles['banner-background-image']}>
    <div className={classNames(styles['the-client'], styles['custom-client-container'], styles['brand-logosx3'], styles['multiple-brand-logos'], styles['without-hero-banner'])}>
     {images?.bannerDesktop && <>
       <Image src={`${images?.bannerDesktop}?t=${currentDateTimeStamp()}`} className={classNames(styles['logo-banner-img'], styles['desktop'])} priority={true} alt={'banner-background'} width={1280} height={212} unoptimized={true} />
       <div className={styles['client-border']}></div>
      </>}
     {images?.bannerMobile && <>
       {' '}
       <Image src={`${images?.bannerMobile}?t=${currentDateTimeStamp()}`} className={classNames(styles['logo-banner-img'], styles['mobile'])} priority={true} alt={'banner-background'} width={1280} height={212} unoptimized={true} />
       <div className={styles['client-border']}></div>
      </>}
     <div className={classNames(styles['client-details'], styles['titleLineBreak'])}>
      <h2 className={styles['org-title']} data-bdd={'client-banner-heading'} data-testid={'client-banner-heading'}>
       {parse(sanitizeTitle(orgName))}
      </h2>
      <p className={styles['client-details-bottom']}>
       <span className={styles['resource-count']} data-bdd={'resource-count'}>
        <Image src={resourcesIcon} className={styles['icon-center-text']} alt="Resources Found" data-sentry-element="Image" data-sentry-source-file="ClientLogoBanner.tsx" />
        {orgNumFound + ' ' + t('Resources') + ' '}
       </span>
       <span className={styles['client-link']} data-bdd={'client-link'}>
        {orgUrl ? <>
          {' '}
          <Image src={orgIcon} className={styles['icon-center-text']} alt="Org Link" />
          <a className={'text-links-body-color'} href={orgUrl} target="_blank" rel={'nofollow'}>
           {' '}
           {orgSiteName(orgUrl)}
          </a>
         </> : ''}
       </span>
      </p>
     </div>
    </div>

    <div className={styles['client-banner-strapline']}>
     <TruncateReadmore classToken={'client-description'} numberOfLines={2} trimBy={'words'} text={sanitizeTitle(orgDescription)} data-sentry-element="TruncateReadmore" data-sentry-source-file="ClientLogoBanner.tsx" />
    </div>
   </div>
  </div>;
};
export default ClientLogoBanner;